import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnvil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnvil"><Path d="M21 10.2812L20.2422 10.4697L18.1826 10.9854C17.4876 11.1592 17 11.7835 17 12.5C17 13.2165 17.4876 13.8408 18.1826 14.0146L20.2422 14.5303L21 14.7188V20H4V14.7188L4.75781 14.5303L6.65332 14.0557C7.44458 13.8578 8 13.1467 8 12.3311C7.99985 11.6202 7.57627 10.9773 6.92285 10.6973L6.5 10.5156V4H21V10.2812Z" fill="currentColor"/><Path d="M5 9.87305L1 8.15918V4H5V9.87305Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnvil;
